import { render } from "./AAvatar.vue?vue&type=template&id=0e8164fc"
import script from "./AAvatar.vue?vue&type=script&lang=js"
export * from "./AAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__